<template>
  <v-autocomplete
    v-model="selectedProduct"
    v-model:search="searchTerm"
    class="no-menu-icon combobox-role"
    :loading="loading"
    :items="items"
    :placeholder="$t('addProducts')"
    variant="solo"
    clearable
    hide-no-data
    hide-selected
    hide-details
    no-filter
    color="primary"
    item-value="[title,ean,productId,manufacturerProductId]"
    item-title="title"
    return-object
    :maxlength="SEARCH_FIELD_MAX_LENGTH"
    :menu-props="menuProps"
    @update:focused="
      (focus) => {
        !focus ? resetInput : ''
      }
    "
  >
    <template #prepend-inner="{ isFocused }">
      <v-icon :color="isFocused.value ? 'primary' : ''" :icon="mdiMagnify" />
    </template>
    <template #item="{ item, props }">
      <instant-search-product-item
        v-bind="props"
        :item="item"
        :search-term="searchTerm"
        density="comfortable"
      />
    </template>
  </v-autocomplete>
</template>

<script setup lang="ts">
import InstantSearchProductItem from '@/modules/search/components/InstantSearchProductItem.vue'
import { SEARCH_FIELD_MAX_LENGTH } from '@/modules/search/constants'
import useInstantProductSearch from '@/modules/search/useInstantProductSearch'
import { MediumProduct } from '@/types/index'
import { mdiMagnify } from '@mdi/js'
import { storeToRefs } from 'pinia'
import { ref, watch } from 'vue'

const emit = defineEmits<{
  productSelected: [number]
}>()
const selectedProduct = ref<MediumProduct>()
const timerId = ref<NodeJS.Timeout>()
const searchTerm = ref<string>()
const { items, loading } = storeToRefs(useInstantProductSearch())

const resetInput = () => {
  searchTerm.value = undefined
  selectedProduct.value = undefined
  useInstantProductSearch().clearItems()
}

watch(searchTerm, (value: string | undefined) => {
  clearTimeout(timerId.value)
  timerId.value = setTimeout(() => {
    value = value?.trim()
    if (!value || value.length < 2) {
      useInstantProductSearch().clearItems()
    } else if (value && value.length >= 2) {
      useInstantProductSearch().instantSearch(value)
    }
  }, 400)
})

watch(selectedProduct, (value: MediumProduct | undefined) => {
  if (value) {
    emit('productSelected', value.productId)
    resetInput()
  }
})

const menuProps = { maxHeight: window.innerHeight * 0.6 }
</script>
